// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import NorfolkIsland from '../_raw/flag/icon_flag_norfolk_island.png';

export default () => <img src={NorfolkIsland} alt="NorfolkIsland" />;
